import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TableParams } from '@core/models';
import { ApiUrlService } from '@core/services/common/api-url.service';
import { map } from 'rxjs/operators';
import { createTypesRecursive } from '@shared/services/factories/block-factory.service';
import { ApiDataServiceInterface } from '@core/interfaces/api-data-service.interface';
import { ListInterface } from '@core/interfaces/list/list.interface';
import { CurrencyPreferenceService } from '@shared/services/currency/currency-preference.service';

@Injectable({
  providedIn: 'root'
})
export class ApiDataService implements ApiDataServiceInterface {
  protected apiUrl: string;

  constructor(protected httpClient: HttpClient,
              protected apiUrlService: ApiUrlService,
              protected currencyPreferenceService: CurrencyPreferenceService) {
  }

  getList(data: TableParams): Observable<ListInterface> {
    const url = this.apiUrlService.getApiUrl() + this.apiUrl;
    return this.httpClient.get<ListInterface>(
      this.currencyPreferenceService.appendCurrencyToUrlIfSwitcherExists(url + data.getUrlParams()),
    ).pipe(map(this.mapListData));
  }


  private mapListData(list: ListInterface): ListInterface {

    list.filters = createTypesRecursive(list.filters);
    list.pagination = createTypesRecursive(list.pagination);
    list.sorting = createTypesRecursive(list.sorting);
    list.header = createTypesRecursive(list.header);
    list.noResults = createTypesRecursive(list.noResults);
    list.elements = list.elements.map(view => {
      view.pagination = createTypesRecursive(view?.pagination)
      view.data = view.data?.map(itemBlocks => createTypesRecursive(itemBlocks));
      return view;
    });

    list.tabs = list.tabs ? createTypesRecursive(list.tabs) : [];
    return list;
  }
}
